// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1q1IT","content":"RecentSearches_content__3_fHv"};